import styled from 'styled-components';
import { COLORS } from '@/utils/static';
import { Typography } from 'antd';

export const Label2 = styled.label`
  display: block;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #637381;
  text-align: left;
  margin-bottom: ${({ $marginBottom }) => ($marginBottom ? `${$marginBottom}px` : '4px')};
  text-transform: uppercase;
`;

export const Text = styled(Typography.Text)`
  color: ${({ $color }) => ($color ? $color : '#212B36')};
  margin-bottom: ${({ $marginBottom }) => ($marginBottom ? `${$marginBottom}px` : '0')};
  margin-top: ${({ $marginTop }) => ($marginTop ? `${$marginTop}px` : '0')};
  margin-left: ${(p) => (p.$marginLeft ? `${p.$marginLeft}px` : '0')};
  margin-right: ${(p) => (p.$marginRight ? `${p.$marginRight}px` : '0')};
  padding: ${(p) => (p.$padding ? `${p.$padding}px` : '0')};
  ${(p) => (p.$paddingTop ? `padding-top: ${p.$paddingTop}px` : '')};
  ${({ $fontWeight }) => ($fontWeight ? `font-weight: ${$fontWeight}` : '')};
  ${({ $fontSize }) => ($fontSize ? `font-size: ${$fontSize}px;` : '')};
  ${({ $lineHeight }) => ($lineHeight ? `line-height: ${$lineHeight}px;` : '')};
  ${({ $maxWidth }) => ($maxWidth ? `max-width: ${typeof $maxWidth === 'number' ? `${$maxWidth}px` : $maxWidth};` : '')};
  ${({ $textAlign }) => ($textAlign ? `text-align: ${$textAlign};` : '')};
  ${p => p.$inline ? `display: inline-block;` : ''}
  ${p => p.$textInline ? `display: inline;` : ''}
  ${p => p.$preWrap ? `white-space: pre-wrap;` : ''}
`;

export const Title = styled(Typography.Title)`
  color: ${({ $color }) => $color ? $color : ''};
  margin-bottom: ${({ $marginBottom }) => $marginBottom ? `${$marginBottom}px` : ''};
  margin-top: ${({ $marginTop }) => $marginTop ? `${$marginTop}px` : ''};
  margin-left: ${({ $marginLeft }) => $marginLeft ? `${$marginLeft}px` : ''};
  margin-right: ${({ $marginRight }) => $marginRight ? `${$marginRight}px` : ''};
  padding: ${({ $padding }) => $padding ? `${$padding}px` : ''};
  ${({ $fontWeight }) => $fontWeight ? `font-weight: ${$fontWeight};` : ''};
  ${({ $fontSize }) => $fontSize ? `font-size: ${$fontSize}px;` : ''};
  ${({ $lineHeight }) => $lineHeight ? `line-height: ${$lineHeight}px;` : ''};
  ${({ $textAlign }) => $textAlign ? `text-align: ${$textAlign};` : ''};
  ${({ $paddingCss }) => $paddingCss ? `padding: ${$paddingCss};` : ''};
`;

const RobotoTemplate = styled(Text)`
  font-family: 'Roboto Mono', monospace;
  color: ${(p) => (p.$color ? p.$color : COLORS.aragonBlue)};
`;

export const Body1Light = styled(Text)`
  font-weight: 300;
  font-size: 18px;
  line-height: 28px;
`;

export const Body2Light = styled(Text)`
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
`;

export const Body2 = styled(Text)`
  font-size: 16px;
  line-height: 22px;
`;

export const Body3Light = styled(Text)`
  font-weight: 300;
  font-size: 14px;
  line-height: 21px;
`;

export const Body4Light = styled(Text)`
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
`;

export const Body4 = styled(Text)`
  font-size: 12px;
  line-height: 16px;
`;

export const Label = styled.label`
  display: block;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  text-transform: uppercase;
  color: ${({ $color }) => ($color ? $color : '#637381')};
  margin-top: ${(p) => (p.$marginTop ? `${p.$marginTop}px` : '0')};
  margin-bottom: ${(p) => (p.$marginBottom ? `${p.$marginBottom}px` : '0')};
  margin-left: ${(p) => (p.$marginLeft ? `${p.$marginLeft}px` : '0')};
`;

// Roboto
export const RobotoBody4 = styled(RobotoTemplate)`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
`;

export const AntdTypographyWrapper = styled.div`
  font-weight: 400;
`;

export const Span = styled.span`
  ${(p) => (p.$color ? `color: ${p.$color};` : '')}
  ${(p) => (p.$marginLeft ? `margin-left: ${p.$marginLeft}px;` : '')}
`;
